import { Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { useTranslation } from "react-i18next";

const WarehouseDetailAdditional = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <NFTextInput fieldName={"actualAddress"} title={t("Actual address")} />
      </Row>
      <Row>
        <NFTextInput fieldName={"phoneNumber"} title={t("Phone")} />
      </Row>
    </>
  );
};

export default WarehouseDetailAdditional;
